export const users = [
  {
    id: 1,
    fullname: 'User',
    email: 'user@gmail.com',
    password: 123456,
  },
  {
    id: 1,
    email: 'user1@gmail.com',
    fullname: 'User 1',
    password: 123456,
  },
  {
    id: 1,
    email: 'user2@gmail.com',
    fullname: 'User 2',
    password: 123456,
  },
];
